{
  "(optional)": "(opciono)",
  "(required)": "(obavezno)"
}